import React, { useState } from "react";
import Searchpatient from './Searchpatient';
import { VIEWCONSTANT } from "../../../AppConstant/ViewConstant";

const SickleMainModel = ({ onClose, openSickleForm, onSelect }) => {

    const [searchModal, setSearchModal] = useState(false);

    return (
        <>
            <div className="modal fade show d-block verificationModel" id="exampleModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ background: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header border-bottom-0 ">
                            <div className="text-center headerText">
                                <h5 className="modal-title" id="exampleModalLabel">Sickle Cell</h5>
                            </div>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose} />
                        </div>
                        <div className="modal-body">
                            <div className="sickCellRow row">
                                {!localStorage.getItem("sickle_refresh_token") && (
                                    <div className="col-md-12 text-center">
                                        You are not logged in with SCD program. Please login !
                                    </div>
                                )}

                                {localStorage.getItem("sickle_refresh_token") && (
                                    <>
                                        {
                                            /* <div className="sickCellCol opacity-50 pe-none col-xs-12 col-md-4">
                                                <div className="circleImg">
                                                    <span>
                                                        <img src={"/images/Sick/test-reports.png"} />
                                                    </span>
                                                </div>
                                                <div className="sickColTitle">
                                                    <h5>Test Reports</h5>
                                                </div>
                                            </div> */
                                        }
                                        <div className=" col-xs-12 col-md-4" >
                                            <div className="sickCellCol" onClick={openSickleForm}>
                                                <div className="circleImg">
                                                    <span>
                                                        <img src={"/images/Sick/hand.png"} />
                                                    </span>
                                                </div>
                                                <div className="sickColTitle">
                                                    <h5>View/Add Results</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className=" col-xs-12 col-md-4" >
                                            <div className="sickCellCol " onClick={() => (onSelect(VIEWCONSTANT.DiseaseManagement), onClose())} >
                                                <div className="circleImg">
                                                    <span>
                                                        <img src={"/images/Sick/daster-management.png"} />
                                                    </span>
                                                </div>
                                                <div className="sickColTitle">
                                                    <h5>Disease Management</h5>
                                                </div>
                                            </div>
                                        </div>
                                    <div className=" col-xs-12 col-md-4">
                                            <div className="sickCellCol " onClick={() => (onSelect(VIEWCONSTANT.medicalHistory), onClose())}>
                                                <div className="circleImg">
                                                    <span>
                                                        <img src={"/images/Sick/CBAC.png"} />
                                                    </span>
                                                </div>
                                                <div className="sickColTitle">
                                                    <h5>Medical History</h5>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default SickleMainModel;